var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 1.66602C2.74619 1.66602 2 2.41221 2 3.33268V16.666C2 17.5865 2.74619 18.3327 3.66667 18.3327H17C17.9205 18.3327 18.6667 17.5865 18.6667 16.666V3.33268C18.6667 2.41221 17.9205 1.66602 17 1.66602H3.66667ZM15.0431 7.77743C15.3685 7.45199 15.3685 6.92435 15.0431 6.59892C14.7176 6.27348 14.19 6.27348 13.8645 6.59892L8.83139 11.6321L6.80207 9.60276C6.47663 9.27733 5.94899 9.27733 5.62355 9.60277C5.29812 9.92821 5.29812 10.4558 5.62356 10.7813L8.24215 13.3998C8.56758 13.7253 9.09522 13.7253 9.42065 13.3998L15.0431 7.77743Z",
    fill: "#5FCF75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.503b75acaa9372019b1655414ab15871.svg";
export { ForwardRef as ReactComponent };